<script>
// import axios from "axios";

import Layout from "../../layouts/main";
import PageHeader from "@/components/page-header";
import appConfig from "@/app.config";
import { mapActions, mapGetters } from "vuex";
import { ModelListSelect } from "vue-search-select";
import Multiselect from "vue-multiselect";

/**
 * Advanced table component
 */
export default {
  page: {
    title: "Test Sets",
    meta: [
      {
        name: "description",
        content: appConfig.description,
      },
    ],
  },
  components: {
    Layout,
    PageHeader,
    ModelListSelect,
    Multiselect,
  },
  data() {
    return {
      title: "Test Sets Contributions",
      items: [
        {
          text: "Home",
          href: "/",
        },
        {
          text: "Test Sets",
          active: true,
        },
      ],
      totalRows: 1,
      currentPage: 1,
      perPage: 10,
      pageOptions: [10, 25, 50, 100],
      filter: null,
      filterOn: [],
      sortBy: "age",
      sortDesc: false,
      fields: [
        {
          key: "index",
          label: "No",
          sortable: true,
        },
        {
          key: "test.name",
          label: "Set Name",
          sortable: true,
        },
        {
          key: "class.name",
          label: "Class",
          sortable: true,
        },
        {
          key: "marked",
          label: "Marked",
          sortable: true,
        },
        {
          key: "converted",
          label: "Converted",
          sortable: true,
        },
        {
          key: "user.name",
          label: "Added By",
          sortable: true,
        },
        {
          key: "addedon",
          label: "Added",
          sortable: true,
        },
        {
          sortable: false,
          key: "actions",
          label: "ACTIONS",
        },
      ],
      data: {
        test: "",
        marked: "",
        converted: "",
        class: "",
      },
      deletedata: {
        name: "",
        id: "",
      },
      editdata: {
        name: "",
        class: "",
        test: "",
        marked: "",
        converted: "",
        id: "",
      },
      testError: "",
      classError: "",
      convertError: "",
      markError: "",
      modal: "",
    };
  },
  computed: {
    ...mapGetters("classes", ["AllClasses", "SaveStatus"]),
    ...mapGetters("coursework", ["TestMarked", "AllSets", "SaveStatus"]),
    ...mapGetters("auth", ["getCurrentUser"]),
    /**
     * Total no. of records
     */
    rows() {
      return this.TestMarked ? this.TestMarked.length : 1;
    },
  },
  mounted() {
    // Set the initial number of items
    this.totalRows = this.TestMarked ? this.TestMarked.length : 1;
  },
  methods: {
    ...mapActions({
      FetchClasses: "classes/fetchClasses",
      FetchSets: "coursework/fetchSets",
      FetchSetContribution: "coursework/fetchSetContributions",
      AddSetting: "coursework/addSetting",
      EditSetting: "coursework/editSetting",
      DeleteSetting: "coursework/deleteSetting",
    }),

    /**
     * Search the table data with search input
     */
    onFiltered() {
      // Trigger pagination to update the number of buttons/pages due to filtering
      this.totalRows = this.TestMarked ? this.TestMarked.length : 1;
      this.currentPage = 1;
    },

    resetError() {
      this.nameError = "";
    },

    resetAddModal() {
      this.data.class = "";
      this.data.test = "";
      this.data.marked = "";
      this.data.converted = "";
      this.resetError();
    },
    resetEditModal() {
      this.editdata.name = "";
      this.editdata.class = "";
      this.editdata.test = "";
      this.editdata.marked = "";
      this.editdata.converted = "";
      this.resetError();
    },
    resetDeleteModal() {
      this.deletedata.name = "";
      this.deletedata.id = "";
    },

    checknumber() {
      //when creating a new one
      if (this.data.marked != "") {
        if (this.data.marked > 100 || parseInt(this.data.marked < 1)) {
          this.markError = "Mark should be between 1 and 100";
        } else {
          this.markError = "";
        }
      }
      if (this.data.converted != "") {
        if (this.data.converted > 100 || parseInt(this.data.converted < 1)) {
          this.convertError = "Value should be between 1 and 100";
        } else {
          this.convertError = "";
        }
      }
    },
    addSetting(modal) {
      if (this.data.test == "") {
        this.nameError = "Test Set is required";
        return;
      } else {
        this.nameError = "";
      }
      if (this.data.class == "") {
        this.classError = "Class field can't be empty";
        return;
      } else {
        this.classError = "";
      }
      if (this.data.marked == "") {
        this.markError = "Mark field can't be empty";
        return;
      } else {
        this.markError = "";
      }
      if (this.data.converted == "") {
        this.convertError = "Converted field can't be empty";
        return;
      } else {
        this.convertError = "";
      }
      this.modal = modal;
      this.AddSetting(this.data);
      this.resetError();
      this.resetAddModal();
      this.closeModal(this.modal);
    },
    showEditModal(values) {
      this.editdata.id = values.item.id;
      this.editdata.name = values.item.test.name;
      this.editdata.class = values.item.class.short;
      this.editdata.test = values.item.test.id;
      this.editdata.marked = values.item.marked;
      this.editdata.converted = values.item.converted;
    },
    showDeleteModal(values) {
      this.deletedata.id = values.item.id;
      this.deletedata.name = values.item.test.name;
      this.deletedata.class = values.item.class.short;
    },
    deleteSetting(modal) {
      this.modal = modal;
      this.DeleteSetting(this.deletedata);
      this.closeModal(modal);
    },
    editSetting(modal) {
      if (this.editdata.test == "") {
        this.nameError = "Test Set is required";
        return;
      } else {
        this.nameError = "";
      }
      if (this.editdata.marked == "") {
        this.markError = "Mark field can't be empty";
        return;
      } else {
        this.markError = "";
      }
      if (this.editdata.converted == "") {
        this.convertError = "Converted field can't be empty";
        return;
      } else {
        this.convertError = "";
      }
      this.modal = modal;
      this.EditSetting(this.editdata);
      this.resetError();
      this.closeModal(this.modal);
    },

    closeModal(modalId) {
      this.$nextTick(() => {
        this.$bvModal.hide(modalId);
      });
    },
  },
  created() {
    this.FetchSets();
    this.FetchClasses();
    this.FetchSetContribution();
  },
};
</script>

<template>
  <Layout>
    <PageHeader :title="title" :items="items" />

    <div
      class="row"
      v-if="
        getCurrentUser.permissions.find((item) =>
          item.permission.includes('view_test_contribution')
        )
      "
    >
      <div class="col-12">
        <div class="card">
          <div class="card-body">
            <div class="row">
              <div class="col-9">
                <h3 class="card-title text-primary">
                  List of Test Set Contributions
                </h3>
              </div>
              <div class="col-3">
                <button
                  v-b-modal.add-setting-modal
                  v-if="
                    getCurrentUser.permissions.find((item) =>
                      item.permission.includes('add_test_contribution')
                    )
                  "
                  class="btn btn-sm btn-primary float-end"
                >
                  <i class="fa fa-plus"></i> Add New
                </button>
              </div>
            </div>
            <div class="row mt-2">
              <div class="col-sm-12 col-md-6">
                <div id="tickets-table_length" class="dataTables_length">
                  <label class="d-inline-flex align-items-center">
                    Show&nbsp;
                    <b-form-select
                      class="form-select form-select-sm"
                      v-model="perPage"
                      size="sm"
                      :options="pageOptions"
                    ></b-form-select
                    >&nbsp;entries
                  </label>
                </div>
              </div>
              <!-- Search -->
              <div class="col-sm-12 col-md-6">
                <div
                  id="tickets-table_filter"
                  class="dataTables_filter text-md-end"
                >
                  <label class="d-inline-flex align-items-center">
                    Search:
                    <b-form-input
                      v-model="filter"
                      type="search"
                      placeholder="Search..."
                      class="form-control form-control-sm ms-2"
                    ></b-form-input>
                  </label>
                </div>
              </div>
              <!-- End search -->
            </div>
            <!-- Table -->
            <div class="table-responsive mb-0">
              <b-table
                class="datatables"
                :items="TestMarked ? TestMarked : []"
                :fields="fields"
                responsive="sm"
                :per-page="perPage"
                :current-page="currentPage"
                :sort-by.sync="sortBy"
                :sort-desc.sync="sortDesc"
                :filter="filter"
                :filter-included-fields="filterOn"
                @filtered="onFiltered"
              >
                <template #cell(index)="data">
                  {{ data.index + 1 }}
                </template>
                <template #cell(actions)="data">
                  <b-button-group>
                    <b-button
                      size="sm"
                      variant="primary"
                      v-b-modal.edit-setting-modal
                      @click="showEditModal(data)"
                      v-if="
                        getCurrentUser.permissions.find((item) =>
                          item.permission.includes('edit_test_contribution')
                        )
                      "
                      ><i class="fa fa-edit"></i> Edit</b-button
                    >
                    <b-button
                      size="sm"
                      variant="danger"
                      v-b-modal.delete-setting-modal
                      @click="showDeleteModal(data)"
                      v-if="
                        getCurrentUser.permissions.find((item) =>
                          item.permission.includes('delete_test_contribution')
                        )
                      "
                      ><i class="fa fa-trash"></i> Delete</b-button
                    >
                  </b-button-group>
                </template>
              </b-table>
            </div>
            <div class="row">
              <div class="col">
                <div
                  class="dataTables_paginate paging_simple_numbers float-end"
                >
                  <ul class="pagination pagination-rounded mb-0">
                    <!-- pagination -->
                    <b-pagination
                      v-model="currentPage"
                      :total-rows="rows"
                      :per-page="perPage"
                    ></b-pagination>
                  </ul>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      <!-- modal starts -->
      <b-modal
        id="add-setting-modal"
        hide-footer
        @hidden="resetAddModal()"
        v-if="
          getCurrentUser.permissions.find((item) =>
            item.permission.includes('add_test_contribution')
          )
        "
      >
        <template #modal-title> Add New Test Contribution</template>
        <div class="form-group">
          <label>Test Set <small class="text-danger">*</small></label>
          <div class="input-group">
            <model-list-select
              :list="AllSets ? AllSets : []"
              v-model="data.test"
              option-value="id"
              option-text="name"
              class="mb-3"
              placeholder="Select Test Set"
              @input="resetError()"
            >
            </model-list-select>
            <div class="text-danger" v-if="testError">
              <em>{{ testError }}</em>
            </div>
          </div>
        </div>
        <div class="form-group mb-3">
          <label>Marked Out Of <small class="text-danger">*</small></label>
          <div class="input-group">
            <input
              type="number"
              placeholder="Marked Out Of"
              class="form-control"
              @input="resetError(), checknumber()"
              v-model="data.marked"
            />
          </div>
          <div class="text-danger" v-if="markError">
            <em>{{ markError }}</em>
          </div>
        </div>
        <div class="form-group mb-3">
          <label>Converted To <small class="text-danger">*</small></label>
          <div class="input-group">
            <input
              type="number"
              placeholder="Coverted To"
              class="form-control"
              @input="resetError(), checknumber()"
              v-model="data.converted"
            />
          </div>
          <div class="text-danger" v-if="convertError">
            <em>{{ convertError }}</em>
          </div>
        </div>
        <div class="form-group">
          <label>Class(es) <small class="text-danger">*</small></label>
          <div class="input-group">
            <multiselect
              v-model="data.class"
              :height="300"
              :options="AllClasses ? AllClasses : []"
              :multiple="true"
              :taggable="true"
              :close-on-select="false"
              :clear-on-select="false"
              :preserve-search="true"
              tag-placeholder="Add a class"
              placeholder="Search or add a class"
              label="name"
              track-by="id"
              :preselect-first="false"
            >
              <template slot="selection" slot-scope="{ values, isOpen }"
                ><span
                  class="multiselect__single"
                  v-if="values.length &amp;&amp; !isOpen"
                  >{{ values.length }} options selected</span
                ></template
              >
            </multiselect>
          </div>
          <div class="text-danger" v-if="classError">
            <em>{{ classError }}</em>
          </div>
        </div>
        <div class="modal-footer">
          <button
            type="button"
            class="btn btn-sm btn-outline-danger"
            data-dismiss="modal"
            @click="closeModal('add-setting-modal')"
          >
            <i class="fa fa-times"></i> Close
          </button>
          <button
            type="button"
            class="btn btn-sm btn-outline-primary"
            @click="addSetting('add-setting-modal')"
          >
            <i class="fa fa-check"></i>
            Submit
            <b-spinner
              v-if="SaveStatus"
              variant="light"
              small
              label="Spinning"
            ></b-spinner>
          </button>
        </div>
      </b-modal>
      <!-- modal ends -->
      <!-- edit modal starts -->
      <b-modal
        id="edit-setting-modal"
        hide-footer
        @hidden="resetEditModal()"
        v-if="
          getCurrentUser.permissions.find((item) =>
            item.permission.includes('edit_test_contribution')
          )
        "
      >
        <template #modal-title>
          Edit Setting for {{ editdata.name }} ({{ editdata.class }})</template
        >
        <div class="form-group">
          <label>Test Set <small class="text-danger">*</small></label>
          <div class="input-group">
            <model-list-select
              :list="AllSets ? AllSets : []"
              v-model="editdata.test"
              option-value="id"
              option-text="name"
              class="mb-3"
              placeholder="Select Test Set"
              @input="resetError()"
            >
            </model-list-select>
            <div class="text-danger" v-if="testError">
              <em>{{ testError }}</em>
            </div>
          </div>
        </div>
        <div class="form-group mb-3">
          <label>Marked Out Of <small class="text-danger">*</small></label>
          <div class="input-group">
            <input
              type="number"
              placeholder="Marked Out Of"
              class="form-control"
              @input="resetError(), checknumber()"
              v-model="editdata.marked"
            />
          </div>
          <div class="text-danger" v-if="markError">
            <em>{{ markError }}</em>
          </div>
        </div>
        <div class="form-group mb-3">
          <label>Converted To <small class="text-danger">*</small></label>
          <div class="input-group">
            <input
              type="number"
              placeholder="Coverted To"
              class="form-control"
              @input="resetError(), checknumber()"
              v-model="editdata.converted"
            />
          </div>
          <div class="text-danger" v-if="convertError">
            <em>{{ convertError }}</em>
          </div>
        </div>
        <div class="modal-footer">
          <button
            type="button"
            class="btn btn-sm btn-outline-danger"
            data-dismiss="modal"
            @click="closeModal('edit-setting-modal')"
          >
            <i class="fa fa-times"></i> Close
          </button>
          <button
            type="button"
            class="btn btn-sm btn-outline-primary"
            @click="editSetting('edit-setting-modal')"
          >
            <i class="fa fa-check"></i>
            Save Changes</button
          ><b-spinner
            v-if="SaveStatus"
            variant="primary"
            small
            label="Saving"
          ></b-spinner>
        </div>
      </b-modal>
      <!-- modal ends -->

      <!-- modal delete setting starts -->
      <b-modal
        id="delete-setting-modal"
        hide-footer
        @hidden="resetDeleteModal"
        v-if="
          getCurrentUser.permissions.find((item) =>
            item.permission.includes('delete_test_contribution')
          )
        "
      >
        <template #modal-title>
          <h4 class="text-danger">
            Delete Setting {{ deletedata.name }} ({{ deletedata.class }})
          </h4></template
        >
        <div class="form-group mb-3">
          <div class="input-group">
            <h5>
              Do you want to delete Contribution for {{ deletedata.name }}?
              Click Proceed Button to delete.
            </h5>
          </div>
        </div>
        <div class="modal-footer">
          <button
            type="button"
            class="btn btn-sm btn-outline-secondary"
            data-dismiss="modal"
            @click="closeModal('delete-setting-modal')"
          >
            <i class="fa fa-times"></i> Close
          </button>
          <button
            type="button"
            class="btn btn-sm btn-outline-danger"
            @click="deleteSetting('delete-setting-modal')"
          >
            <i class="fa fa-trash"></i> Confirm</button
          ><b-spinner
            v-if="SaveStatus"
            variant="primary"
            small
            label="Deleting"
          ></b-spinner>
        </div>
      </b-modal>
      <!-- modal ends -->
    </div>
    <div class="row d-flex" v-else>
      <div class="col-md-8 mx-auto">
        <div class="jumbotron py-5 text-center">
          <strong class="display-6 text-danger">
            Access Denied <i class="fa fa-exclamation" aria-hidden="true"></i
          ></strong>
          <p class="lead text-muted py-4">
            Request For Permission From Administrator
          </p>
        </div>
      </div>
    </div>
  </Layout>
</template>
